import {TOGGLE_OPEN_FILTER_BLOCK_BY_BUTTON, TOGGLE_OPEN_FILTER_BLOCK_BY_MOUSE} from "./actionTypes";

export const toggleOpenFilterBlock = (isOpen, isMouseAction) => (dispatch, getState) => {
    if (isMouseAction) {
        dispatch({type: TOGGLE_OPEN_FILTER_BLOCK_BY_MOUSE, payload: isOpen});
    } else {
        dispatch({type: TOGGLE_OPEN_FILTER_BLOCK_BY_BUTTON, payload: isOpen});
    }

};